import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { NotificationService } from '../../service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { startWith, map } from 'rxjs/operators';
import { CommSummaryModel } from '../../models/commissionsummary/commsummary.model';
import { CommissionSummaryService } from '../../service/commission-summary.service';
import { GlobalService } from 'src/app/service/global.service';
import { HomeService } from 'src/app/service/home.service';
import { HomeModel } from 'src/app/models/home/home.model';

@Component({
  selector: 'app-search-comm-plan',
  templateUrl: './review-comms-search-sup.component.html',
  styleUrls: ['./review-comms-search-sup.component.css']
})
export class ReviewCommissionsSearchSupComponent implements OnInit {

  public commSummaryModel = new CommSummaryModel();

  private subscriptions: Subscription[] = [];

  dropDownsData: CommSummaryModel[] = [];
  filteredSalesChannelsData: CommSummaryModel[] = [];
  filteredCommPlansData: CommSummaryModel[] = [];
  filteredCalendarTypeData: CommSummaryModel[] = [];
  filteredValidToDatesData: CommSummaryModel[] = [];
  getValidToDate: CommSummaryModel[] = [];
  getToDate: CommSummaryModel[] = [];
  effectiveDateData: CommSummaryModel[] = [];
  disputeclosedata: HomeModel[] = [];

  filteredSalesChannelValues: Observable<CommSummaryModel[]> | undefined;
  controlSc = new FormControl();
  filteredCommissionPlans: Observable<CommSummaryModel[]> | undefined;
  controlCp = new FormControl();
  filteredCalendarTypes: Observable<CommSummaryModel[]> | undefined;
  controlCt = new FormControl();
  filteredValidToDates: Observable<CommSummaryModel[]> | undefined;
  controlVtDt = new FormControl();

  searchCriteriaSet = new Set<string>();

  public effectiveDate: any;
  checkedactive: boolean = false;
  commplansdata: HomeModel[] = [];
  commplansdataSup: HomeModel[] = [];
  commplansdataFiltered: HomeModel[] = [];
  loggedincommplanid: number = 0;
  scempid: any;

  constructor(private router: Router, private commissionSummaryService: CommissionSummaryService,
    private authGaurdService: AuthGaurdService, private notificationService: NotificationService, private globalService: GlobalService, private homeService: HomeService) {
    globalService._disableBackButton();
  }

  ngOnInit() {
    this.getCommplansList();

    this.commSummaryModel.salesChannel = localStorage.getItem('sc');
    this.commSummaryModel.commPlanId = localStorage.getItem('commplan');
    this.commSummaryModel.calRunId = localStorage.getItem('calrunid');
  }

  getCommplansList() {
    console.log(localStorage.getItem('CURRENT_USERROLE_SESSION'));
    console.log(localStorage.getItem('CURRENT_EMPLOYEEID_SESSION'));
    this.homeService.getCommplansList(localStorage.getItem('CURRENT_EMPLOYEEID_SESSION'), localStorage.getItem('CURRENT_USERROLE_SESSION'))
      .subscribe((data: any) => {
        this.commplansdata = data;
        this.commplansdataSup = JSON.parse(JSON.stringify(data));
        this.commplansdataFiltered = JSON.parse(JSON.stringify(data));

        if (data.length > 0) {
          this.getDropDownsData();
        }
      },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
  }

  public getDropDownsData(): void {

    this.commplansdataSup = this.commplansdata.filter(comm => comm.user_role === 'Supervisor');
    this.loggedincommplanid = this.commplansdataSup[0].comm_plan_id;

    this.subscriptions.push(
      this.commissionSummaryService.getSupDropDownsData(localStorage.getItem('CURRENT_EMPLOYEEID_SESSION')).subscribe(
        (response: CommSummaryModel[]) => {
          this.dropDownsData = response;
          // console.log(JSON.stringify(this.dropDownsData));

          this.filteredSalesChannelsData = this.dropDownsData.filter((v, i) => this.dropDownsData.findIndex(item => item.salesChannel != "" && item.salesChannel == v.salesChannel) === i);
          this.filteredSalesChannelsData = this.filteredSalesChannelsData.sort((a, b) => (a.salesChannel < b.salesChannel) ? -1 : 1);

          this.filteredCommPlansData = this.dropDownsData.filter((v, i) => this.dropDownsData.findIndex(item => item.commPlan == v.commPlan) === i);
          this.filteredCommPlansData = this.filteredCommPlansData.sort((a, b) => (a.commPlan < b.commPlan) ? -1 : 1);

          this.filteredValidToDatesData = this.dropDownsData.filter((v, i) => this.dropDownsData.findIndex(item => item.calRunId == v.calRunId) === i);
          this.filteredValidToDatesData = this.filteredValidToDatesData.filter(item => this._normalizeValue(item.issalesrepaccess).startsWith("y"));

          if (localStorage.getItem('calrunid')) {
            // if (localStorage.getItem('calrunid').length > 0) {
            const filterValue = this.globalService._normalizeValue(localStorage.getItem('calrunid'));
            this.getValidToDate = this.filteredValidToDatesData.filter(item => this.globalService._normalizeValue(item.calRunId).startsWith(filterValue));
            this.getValidToDate = this.getValidToDate.filter((v, i) => this.getValidToDate.findIndex(item => item.validFromDt == v.validFromDt) === i);
            this.getValidToDate = this.getValidToDate.sort((a, b) => (a.validFromDt < b.validFromDt) ? -1 : 1);

            this.getToDate = this.filteredValidToDatesData.filter(item => this.globalService._normalizeValue(item.calRunId).startsWith(filterValue));
            this.getToDate = this.getToDate.filter((v, i) => this.getToDate.findIndex(item => item.validToDt == v.validToDt) === i);
            this.getToDate = this.getToDate.sort((a, b) => (a.validToDt < b.validToDt) ? -1 : 1);

            localStorage.setItem('calrunid', this.commSummaryModel.calRunId);
            // }
            localStorage.setItem('validToDt', JSON.parse(JSON.stringify(this.getValidToDate[0].validFromDt)));
            localStorage.setItem('validLevelToDt', JSON.parse(JSON.stringify(this.getToDate[0].validToDt)));
            localStorage.setItem('level', "0");
          }

        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public getSelectedSc(event: any) {
    const filterValue = this._normalizeValue(event.target.value);

    this.filteredCommPlansData = this.dropDownsData.filter(item => this._normalizeValue(item.salesChannel).startsWith(filterValue));
    this.filteredCommPlansData = this.filteredCommPlansData.filter((v, i) => this.filteredCommPlansData.findIndex(item => item.commPlan == v.commPlan) === i);
    this.filteredCommPlansData = this.filteredCommPlansData.sort((a, b) => (a.commPlan < b.commPlan) ? -1 : 1);

  }

  public getSelectedCommPlan(event: any) {

    const filterValue = this._normalizeValue(event.target.value);
    this.commplansdataFiltered = this.commplansdata.filter(item => this._normalizeValue(item.comm_plan_id.toString()) === filterValue);

    localStorage.setItem('CURRENT_SC_EMP_ID_SESSION', this.commplansdataFiltered[0].scempid);
    console.log(localStorage.getItem('CURRENT_SC_EMP_ID_SESSION'));
  }

  public getSelectedCalendartype(event: any) {
    //console.log(event.target.value);
    const filterValue = this._normalizeValue(event.target.value);
    this.filteredValidToDatesData = this.dropDownsData.filter(item => this._normalizeValue(item.calendarType).startsWith(filterValue));
    this.filteredValidToDatesData = this.filteredValidToDatesData.filter((v, i) => this.filteredValidToDatesData.findIndex(item => item.validToDt == v.validToDt) === i);
    this.filteredValidToDatesData = this.filteredValidToDatesData.sort((a, b) => (b.validToDt < a.validToDt) ? -1 : 1);

  }

  public getSelectedPayrollCalendar(event: any) {
    //console.log(event.target.value);
    if (localStorage.getItem('calrunid').length > 0) {
      const filterValue = this.globalService._normalizeValue(event.target.value);
      this.getValidToDate = this.filteredValidToDatesData.filter(item => this.globalService._normalizeValue(item.calRunId).startsWith(filterValue));
      this.getValidToDate = this.getValidToDate.filter((v, i) => this.getValidToDate.findIndex(item => item.validFromDt == v.validFromDt) === i);
      this.getValidToDate = this.getValidToDate.sort((a, b) => (a.validFromDt < b.validFromDt) ? -1 : 1);

      this.getToDate = this.filteredValidToDatesData.filter(item => this.globalService._normalizeValue(item.calRunId).startsWith(filterValue));
      this.getToDate = this.getToDate.filter((v, i) => this.getToDate.findIndex(item => item.validToDt == v.validToDt) === i);
      this.getToDate = this.getToDate.sort((a, b) => (a.validToDt < b.validToDt) ? -1 : 1);

      localStorage.setItem('calrunid', this.commSummaryModel.calRunId);
    }
    localStorage.setItem('validToDt', JSON.parse(JSON.stringify(this.getValidToDate[0].validFromDt)));
    localStorage.setItem('validLevelToDt', JSON.parse(JSON.stringify(this.getToDate[0].validToDt)));
    localStorage.setItem('level', "0");
  }

  public startCalc(): void {
    const formData = null;
    this.subscriptions.push(
      this.commissionSummaryService.startCalc(formData).subscribe(
        (response: CommSummaryModel[]) => {
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public redirect(url: string, pageName: string) {
    //this.getDropDownsData();
    if (this.commSummaryModel.calRunId === "null" || this.commSummaryModel.calRunId === null) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please select Payroll End Date');
    } else {
      localStorage.setItem('sc', this.commSummaryModel.salesChannel);
      localStorage.setItem('country', this.commSummaryModel.country ?? '');
      localStorage.setItem('commplan', this.commSummaryModel.commPlanId);
      localStorage.setItem('calrunid', this.commSummaryModel.calRunId);

      if (this.checkedactive === true) {
        console.log("IF");
        this.commSummaryModel.extra_sc_emp_id = 0;
        this.commSummaryModel.sc_emp_id = "NA";
        this.commSummaryModel.sup_extra_sc_emp_id = 0;
        this.commSummaryModel.sup_sc_emp_id = "NA";
        this.commSummaryModel.extra_comm_plan_id = 0;
        this.commSummaryModel.comm_plan_id = 0;
      } else {
        console.log("ELSE");
        this.commSummaryModel.extra_sc_emp_id = 1;
        this.commSummaryModel.sc_emp_id = "NA";
        this.commSummaryModel.sup_extra_sc_emp_id = 1;
        this.commSummaryModel.sup_sc_emp_id = "NA";
        this.commSummaryModel.extra_comm_plan_id = 1;
        this.commSummaryModel.comm_plan_id = 0;
      }
      this.commSummaryModel.checkboxstatus = this.checkedactive;

      if (this.commSummaryModel.commPlanId === "--Select Commission Plan--") {
        this.commSummaryModel.commPlanId = null;
      }

      this.commissionSummaryService.commSummaryModel = this.commSummaryModel;
      this.commissionSummaryService.searchCriteriaSet = this.searchCriteriaSet;
      console.log(this.commSummaryModel);
      this.getEffectiveDate(this.commSummaryModel.commPlanId);
      this.getDisputeStatus();

      this.router.navigate(['/' + url], { queryParams: { page: pageName } });
    }
  }

  public getDisputeStatus() {
    console.log("getDisputeStatus() Called");
    this.homeService.getDisputeStatus(this.commSummaryModel.commPlanId, Number(this.commSummaryModel.calRunId))
      .subscribe((data: any) => {
        this.disputeclosedata = data;
        // console.log(this.disputeclosedata);
        //console.log(this.disputeclosedata[0].dispute_close_dt);
        if (this.disputeclosedata.length > 0) {
          if (this.disputeclosedata[0].dispute_close_dt) {
            let d = new Date();
            let d1 = new Date(this.disputeclosedata[0].dispute_close_dt);
            var g1 = new Date(d.getFullYear(), d.getMonth(), d.getDate());
            console.log(g1);
            var g2 = new Date(d1.getFullYear(), d1.getMonth(), d1.getDate());
            console.log(g2);

            if (g1.getTime() < g2.getTime()) {
              console.log("g1 is lesser than g2");
              localStorage.setItem('SESSION_DISPUTE_CLOSE_STATUS', 'valid');
            } else if (g1.getTime() > g2.getTime()) {
              console.log("g1 is greater than g2");
              localStorage.setItem('SESSION_DISPUTE_CLOSE_STATUS', 'notvalid');
            } else {
              console.log("both are equal");
              localStorage.setItem('SESSION_DISPUTE_CLOSE_STATUS', 'valid');
            }
          } else {
            localStorage.setItem('SESSION_DISPUTE_CLOSE_STATUS', 'valid');
          }
        } else {
          localStorage.setItem('SESSION_DISPUTE_CLOSE_STATUS', 'valid');
        }

        console.log(localStorage.getItem('SESSION_DISPUTE_CLOSE_STATUS'));

      },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
  }

  private getEffectiveDate(commPlanId: number) {

    const filterValue = this._normalizeValue(commPlanId.toString());
    this.effectiveDateData = this.dropDownsData.filter(item => this._normalizeValue(item.commPlanId).startsWith(filterValue));


    this.effectiveDateData.forEach(jsonModel => {

      this.effectiveDate = jsonModel.effective_date;
    });

    localStorage.setItem('SESSION_EFFDATE', this.effectiveDate);


  }

  clearSearchCriteria() {

    localStorage.removeItem('sc');
    localStorage.removeItem('commplan');
    localStorage.removeItem('calrunid');

    this.commSummaryModel.salesChannel = null;
    this.commSummaryModel.commPlanId = null;
    this.commSummaryModel.calRunId = null;

    this.getDropDownsData();
  }

  public redirectPage(url: string) {
    this.router.navigate(['/' + url]);
  }

  private _normalizeValue(value: string): string {
    if (value)
      return value.toString().toLowerCase().replace(/\s/g, '');
    else
      return '';
  }

  sortByDate(a, b) {
    if (a.validToDt < b.validToDt) {
      return 1;
    }
    if (a.validToDt > b.validToDt) {
      return -1;
    }
    return 0;
  }

  checkedVal(value: any) {
    console.log(value.currentTarget.checked);
    if (value.currentTarget.checked) {
      console.log("IF");
      this.checkedactive = true;
    } else {
      console.log("ELSE");
      this.checkedactive = false;
    }

  }

}
